import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const wsid = localStorage.getItem("pm_active_workspace_id");
  if (wsid) config.headers["X-Workspace-Id"] = wsid;
  return config;
});

// Diagnostic interceptor — log the failing URL on 404 so future error
// reports can pinpoint the endpoint (the raw AxiosError stack trace only
// shows the bundle.js line, not which API path was hit).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 404) {
      const cfg = error.config || {};
      // eslint-disable-next-line no-console
      console.warn(`[api] 404 ${cfg.method?.toUpperCase()} ${cfg.baseURL || ""}${cfg.url || ""}`);
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
